import { EmotionJSX } from '@emotion/react/types/jsx-namespace';
import { AtlasLogoBrand } from './logos/atlas-logo-brand';
import { AtlasLogoInverse } from './logos/atlas-logo-inverse';
import { AtlasLogoNeutral } from './logos/atlas-logo-neutral';
import { AtlasMarkInverse } from './logos/atlas-mark-inverse';
import { AtlasMarkBrand } from './logos/atlas-mark-brand';
import { AtlasMarkNeutral } from './logos/atlas-mark-neutral';
import { AtlassianAccessLogoBrand } from './logos/atlassianaccess-logo-brand';
import { AtlassianAccessLogoInverse } from './logos/atlassianaccess-logo-inverse';
import { AtlassianAccessLogoNeutral } from './logos/atlassianaccess-logo-neutral';
import { AtlassianAccessMarkBrand } from './logos/atlassianaccess-mark-brand';
import { AtlassianAccessMarkInverse } from './logos/atlassianaccess-mark-inverse';
import { AtlassianAccessMarkNeutral } from './logos/atlassianaccess-mark-neutral';
import { AtlassianAdminLogoBrand } from './logos/atlassianadmin-logo-brand';
import { AtlassianAdminLogoInverse } from './logos/atlassianadmin-logo-inverse';
import { AtlassianAdminLogoNeutral } from './logos/atlassianadmin-logo-neutral';
import { AtlassianAdminMarkBrand } from './logos/atlassianadmin-mark-brand';
import { AtlassianAdminMarkInverse } from './logos/atlassianadmin-mark-inverse';
import { AtlassianAdminMarkNeutral } from './logos/atlassianadmin-mark-neutral';
import { AtlassianAdministrationLogoBrand } from './logos/atlassianadministration-logo-brand';
import { AtlassianAdministrationLogoInverse } from './logos/atlassianadministration-logo-inverse';
import { AtlassianAdministrationLogoNeutral } from './logos/atlassianadministration-logo-neutral';
import { AtlassianAdministrationMarkBrand } from './logos/atlassianadministration-mark-brand';
import { AtlassianAdministrationMarkNeutral } from './logos/atlassianadministration-mark-neutral';
import { AtlassianAdministrationMarkInverse } from './logos/atlassianadministration-mark-inverse';
import { AtlassianAnalyticsLogoBrand } from './logos/atlassiananalytics-logo-brand';
import { AtlassianAnalyticsLogoInverse } from './logos/atlassiananalytics-logo-inverse';
import { AtlassianAnalyticsLogoNeutral } from './logos/atlassiananalytics-logo-neutral';
import { AtlassianAnalyticsMarkBrand } from './logos/atlassiananalytics-mark-brand';
import { AtlassianAnalyticsMarkInverse } from './logos/atlassiananalytics-mark-inverse';
import { AtlassianAnalyticsMarkNeutral } from './logos/atlassiananalytics-mark-neutral';
import { AtlassianBlogMarkNeutral } from './logos/atlassianblog-mark-neutral';
import { AtlassianBlogLogoInverse } from './logos/atlassianblog-logo-inverse';
import { AtlassianBlogLogoNeutral } from './logos/atlassianblog-logo-neutral';
import { AtlassianBlogLogoBrand } from './logos/atlassianblog-logo-brand';
import { AtlassianBlogMarkBrand } from './logos/atlassianblog-mark-brand';
import { AtlassianBlogMarkInverse } from './logos/atlassianblog-mark-inverse';
import { AtlassianCertificationLogoBrand } from './logos/atlassiancertification-logo-brand';
import { AtlassianCertificationLogoInverse } from './logos/atlassiancertification-logo-inverse';
import { AtlassianCertificationLogoNeutral } from './logos/atlassiancertification-logo-neutral';
import { AtlassianCertificationMarkBrand } from './logos/atlassiancertification-mark-brand';
import { AtlassianCertificationMarkInverse } from './logos/atlassiancertification-mark-inverse';
import { AtlassianCertificationMarkNeutral } from './logos/atlassiancertification-mark-neutral';
import { AtlassianCommunityLogoBrand } from './logos/atlassiancommunity-logo-brand';
import { AtlassianCommunityLogoInverse } from './logos/atlassiancommunity-logo-inverse';
import { AtlassianCommunityLogoNeutral } from './logos/atlassiancommunity-logo-neutral';
import { AtlassianCommunityMarkBrand } from './logos/atlassiancommunity-mark-brand';
import { AtlassianCommunityMarkInverse } from './logos/atlassiancommunity-mark-inverse';
import { AtlassianCommunityMarkNeutral } from './logos/atlassiancommunity-mark-neutral';
import { AtlassianDataLakeLogoBrand } from './logos/atlassiandatalake-logo-brand';
import { AtlassianDataLakeLogoInverse } from './logos/atlassiandatalake-logo-inverse';
import { AtlassianDataLakeLogoNeutral } from './logos/atlassiandatalake-logo-neutral';
import { AtlassianDataLakeMarkBrand } from './logos/atlassiandatalake-mark-brand';
import { AtlassianDataLakeMarkInverse } from './logos/atlassiandatalake-mark-inverse';
import { AtlassianDataLakeMarkNeutral } from './logos/atlassiandatalake-mark-neutral';
import { AtlassianDesignLogoBrand } from './logos/atlassiandesign-logo-brand';
import { AtlassianDesignLogoNeutral } from './logos/atlassiandesign-logo-neutral';
import { AtlassianDesignLogoInverse } from './logos/atlassiandesign-logo-inverse';
import { AtlassianDesignMarkBrand } from './logos/atlassiandesign-mark-brand';
import { AtlassianDesignMarkInverse } from './logos/atlassiandesign-mark-inverse';
import { AtlassianDesignMarkNeutral } from './logos/atlassiandesign-mark-neutral';
import { AtlassianDeveloperLogoBrand } from './logos/atlassiandeveloper-logo-brand';
import { AtlassianDeveloperLogoInverse } from './logos/atlassiandeveloper-logo-inverse';
import { AtlassianDeveloperLogoNeutral } from './logos/atlassiandeveloper-logo-neutral';
import { AtlassianDeveloperMarkBrand } from './logos/atlassiandeveloper-mark-brand';
import { AtlassianDeveloperMarkNeutral } from './logos/atlassiandeveloper-mark-neutral';
import { AtlassianDeveloperMarkInverse } from './logos/atlassiandeveloper-mark-inverse';
import { AtlassianDocumentationLogoBrand } from './logos/atlassiandocumentation-logo-brand';
import { AtlassianDocumentationLogoInverse } from './logos/atlassiandocumentation-logo-inverse';
import { AtlassianDocumentationLogoNeutral } from './logos/atlassiandocumentation-logo-neutral';
import { AtlassianDocumentationMarkBrand } from './logos/atlassiandocumentation-mark-brand';
import { AtlassianDocumentationMarkInverse } from './logos/atlassiandocumentation-mark-inverse';
import { AtlassianDocumentationMarkNeutral } from './logos/atlassiandocumentation-mark-neutral';
import { TrelloLogoBrand } from './logos/trello-logo-brand';
import { TrelloLogoInverse } from './logos/trello-logo-inverse';
import { TrelloLogoNeutral } from './logos/trello-logo-neutral';
import { TrelloMarkBrand } from './logos/trello-mark-brand';
import { TrelloMarkInverse } from './logos/trello-mark-inverse';
import { TrelloMarkNeutral } from './logos/trello-mark-neutral';
import { StatuspageLogoBrand } from './logos/statuspage-logo-brand';
import { StatuspageLogoInverse } from './logos/statuspage-logo-inverse';
import { StatuspageLogoNeutral } from './logos/statuspage-logo-neutral';
import { StatuspageMarkBrand } from './logos/statuspage-mark-brand';
import { StatuspageMarkInverse } from './logos/statuspage-mark-inverse';
import { StatuspageMarkNeutral } from './logos/statuspage-mark-neutral';
import { SourcetreeLogoBrand } from './logos/sourcetree-logo-brand';
import { SourcetreeLogoInverse } from './logos/sourcetree-logo-inverse';
import { SourcetreeLogoNeutral } from './logos/sourcetree-logo-neutral';
import { SourcetreeMarkBrand } from './logos/sourcetree-mark-brand';
import { SourcetreeMarkInverse } from './logos/sourcetree-mark-inverse';
import { SourcetreeMarkNeutral } from './logos/sourcetree-mark-neutral';
import { OpsgenieLogoBrand } from './logos/opsgenie-logo-brand';
import { OpsgenieLogoInverse } from './logos/opsgenie-logo-inverse';
import { OpsgenieLogoNeutral } from './logos/opsgenie-logo-neutral';
import { OpsgenieMarkBrand } from './logos/opsgenie-mark-brand';
import { OpsgenieMarkInverse } from './logos/opsgenie-mark-inverse';
import { OpsgenieMarkNeutral } from './logos/opsgenie-mark-neutral';
import { JiraMarkBrand } from './logos/jira-mark-brand';
import { JiraLogoBrand } from './logos/jira-logo-brand';
import { JiraLogoInverse } from './logos/jira-logo-inverse';
import { JiraLogoNeutral } from './logos/jira-logo-neutral';
import { JiraMarkNeutral } from './logos/jira-mark-neutral';
import { JiraMarkInverse } from './logos/jira-mark-inverse';
import { AtlassianLogoBrand } from './logos/atlassian-logo-brand';
import { AtlassianLogoInverse } from './logos/atlassian-logo-inverse';
import { AtlassianLogoNeutral } from './logos/atlassian-logo-neutral';
import { AtlassianMarkBrand } from './logos/atlassian-mark-brand';
import { AtlassianMarkInverse } from './logos/atlassian-mark-inverse';
import { AtlassianMarkNeutral } from './logos/atlassian-mark-neutral';
import { BitbucketLogoBrand } from './logos/bitbucket-logo-brand';
import { BitbucketLogoInverse } from './logos/bitbucket-logo-inverse';
import { BitbucketLogoNeutral } from './logos/bitbucket-logo-neutral';
import { BitbucketMarkNeutral } from './logos/bitbucket-mark-neutral';
import { BitbucketMarkInverse } from './logos/bitbucket-mark-inverse';
import { BitbucketMarkBrand } from './logos/bitbucket-mark-brand';
import { CompassLogoBrand } from './logos/compass-logo-brand';
import { CompassLogoInverse } from './logos/compass-logo-inverse';
import { CompassLogoNeutral } from './logos/compass-logo-neutral';
import { CompassMarkBrand } from './logos/compass-mark-brand';
import { CompassMarkInverse } from './logos/compass-mark-inverse';
import { CompassMarkNeutral } from './logos/compass-mark-neutral';
import { ConfluenceLogoBrand } from './logos/confluence-logo-brand';
import { ConfluenceLogoInverse } from './logos/confluence-logo-inverse';
import { ConfluenceLogoNeutral } from './logos/confluence-logo-neutral';
import { ConfluenceMarkBrand } from './logos/confluence-mark-brand';
import { ConfluenceMarkInverse } from './logos/confluence-mark-inverse';
import { ConfluenceMarkNeutral } from './logos/confluence-mark-neutral';
import { JiraAlignLogoBrand } from './logos/jiraalign-logo-brand';
import { JiraAlignLogoInverse } from './logos/jiraalign-logo-inverse';
import { JiraAlignLogoNeutral } from './logos/jiraalign-logo-neutral';
import { JiraAlignMarkBrand } from './logos/jiraalign-mark-brand';
import { JiraAlignMarkInverse } from './logos/jiraalign-mark-inverse';
import { JiraAlignMarkNeutral } from './logos/jiraalign-mark-neutral';
import { JiraProductDiscoveryLogoBrand } from './logos/jiraproductdiscovery-logo-brand';
import { JiraProductDiscoveryLogoInverse } from './logos/jiraproductdiscovery-logo-inverse';
import { JiraProductDiscoveryLogoNeutral } from './logos/jiraproductdiscovery-logo-neutral';
import { JiraProductDiscoveryMarkBrand } from './logos/jiraproductdiscovery-mark-brand';
import { JiraProductDiscoveryMarkInverse } from './logos/jiraproductdiscovery-mark-inverse';
import { JiraProductDiscoveryMarkNeutral } from './logos/jiraproductdiscovery-mark-neutral';
import { JiraServiceManagementLogoBrand } from './logos/jiraservicemanagement-logo-brand';
import { JiraServiceManagementLogoInverse } from './logos/jiraservicemanagement-logo-inverse';
import { JiraServiceManagementLogoNeutral } from './logos/jiraservicemanagement-logo-neutral';
import { JiraServiceManagementMarkBrand } from './logos/jiraservicemanagement-mark-brand';
import { JiraServiceManagementMarkInverse } from './logos/jiraservicemanagement-mark-inverse';
import { JiraServiceManagementMarkNeutral } from './logos/jiraservicemanagement-mark-neutral';
import { JiraSoftwareLogoBrand } from './logos/jirasoftware-logo-brand';
import { JiraSoftwareLogoInverse } from './logos/jirasoftware-logo-inverse';
import { JiraSoftwareLogoNeutral } from './logos/jirasoftware-logo-neutral';
import { JiraSoftwareMarkBrand } from './logos/jirasoftware-mark-brand';
import { JiraSoftwareMarkInverse } from './logos/jirasoftware-mark-inverse';
import { JiraSoftwareMarkNeutral } from './logos/jirasoftware-mark-neutral';
import { JiraWorkManagementLogoBrand } from './logos/jiraworkmanagement-logo-brand';
import { JiraWorkManagementLogoInverse } from './logos/jiraworkmanagement-logo-inverse';
import { JiraWorkManagementLogoNeutral } from './logos/jiraworkmanagement-logo-neutral';
import { JiraWorkManagementMarkBrand } from './logos/jiraworkmanagement-mark-brand';
import { JiraWorkManagementMarkNeutral } from './logos/jiraworkmanagement-mark-neutral';
import { JiraWorkManagementMarkInverse } from './logos/jiraworkmanagement-mark-inverse';

export interface LogoProps {
  type: 'logo' | 'mark';
  appearance: 'brand' | 'inverse' | 'neutral';
  brand:
    | 'atlas'
    | 'atlassian'
    | 'atlassianaccess'
    | 'atlassianadmin'
    | 'atlassianadministration'
    | 'atlassiananalytics'
    | 'atlassianblog'
    | 'atlassiancertification'
    | 'atlassiancommunity'
    | 'atlassiandatalake'
    | 'atlassiandesign'
    | 'atlassiandeveloper'
    | 'atlassiandocumentation'
    | 'bitbucket'
    | 'compass'
    | 'confluence'
    | 'jiraalign'
    | 'jiraproductdiscovery'
    | 'jiraservicemanagement'
    | 'jirasoftware'
    | 'jiraworkmanagement'
    | 'jira'
    | 'opsgenie'
    | 'sourcetree'
    | 'statuspage'
    | 'trello';
}

type LogoAppearance = {
  brand: EmotionJSX.Element;
  inverse: EmotionJSX.Element;
  neutral: EmotionJSX.Element;
};

type LogoType = {
  mark: LogoAppearance;
  logo: LogoAppearance;
};

interface Logos {
  atlas: LogoType;
  atlassian: LogoType;
  atlassianaccess: LogoType;
  atlassianadmin: LogoType;
  atlassianadministration: LogoType;
  atlassiananalytics: LogoType;
  atlassianblog: LogoType;
  atlassiancertification: LogoType;
  atlassiancommunity: LogoType;
  atlassiandatalake: LogoType;
  atlassiandesign: LogoType;
  atlassiandeveloper: LogoType;
  atlassiandocumentation: LogoType;
  bitbucket: LogoType;
  compass: LogoType;
  confluence: LogoType;
  jiraalign: LogoType;
  jiraproductdiscovery: LogoType;
  jiraservicemanagement: LogoType;
  jirasoftware: LogoType;
  jiraworkmanagement: LogoType;
  jira: LogoType;
  opsgenie: LogoType;
  sourcetree: LogoType;
  statuspage: LogoType;
  trello: LogoType;
}

const Logos: Logos = {
  atlas: {
    logo: {
      brand: <AtlasLogoBrand />,
      inverse: <AtlasLogoInverse />,
      neutral: <AtlasLogoNeutral />
    },
    mark: {
      brand: <AtlasMarkBrand />,
      inverse: <AtlasMarkInverse />,
      neutral: <AtlasMarkNeutral />
    }
  },
  atlassian: {
    logo: {
      brand: <AtlassianLogoBrand />,
      inverse: <AtlassianLogoInverse />,
      neutral: <AtlassianLogoNeutral />
    },
    mark: {
      brand: <AtlassianMarkBrand />,
      inverse: <AtlassianMarkInverse />,
      neutral: <AtlassianMarkNeutral />
    }
  },
  atlassianaccess: {
    logo: {
      brand: <AtlassianAccessLogoBrand />,
      inverse: <AtlassianAccessLogoInverse />,
      neutral: <AtlassianAccessLogoNeutral />
    },
    mark: {
      brand: <AtlassianAccessMarkBrand />,
      inverse: <AtlassianAccessMarkInverse />,
      neutral: <AtlassianAccessMarkNeutral />
    }
  },
  atlassianadmin: {
    logo: {
      brand: <AtlassianAdminLogoBrand />,
      inverse: <AtlassianAdminLogoInverse />,
      neutral: <AtlassianAdminLogoNeutral />
    },
    mark: {
      brand: <AtlassianAdminMarkBrand />,
      inverse: <AtlassianAdminMarkInverse />,
      neutral: <AtlassianAdminMarkNeutral />
    }
  },
  atlassianadministration: {
    logo: {
      brand: <AtlassianAdministrationLogoBrand />,
      inverse: <AtlassianAdministrationLogoInverse />,
      neutral: <AtlassianAdministrationLogoNeutral />
    },
    mark: {
      brand: <AtlassianAdministrationMarkBrand />,
      inverse: <AtlassianAdministrationMarkInverse />,
      neutral: <AtlassianAdministrationMarkNeutral />
    }
  },
  atlassiananalytics: {
    logo: {
      brand: <AtlassianAnalyticsLogoBrand />,
      inverse: <AtlassianAnalyticsLogoInverse />,
      neutral: <AtlassianAnalyticsLogoNeutral />
    },
    mark: {
      brand: <AtlassianAnalyticsMarkBrand />,
      inverse: <AtlassianAnalyticsMarkInverse />,
      neutral: <AtlassianAnalyticsMarkNeutral />
    }
  },
  atlassianblog: {
    logo: {
      brand: <AtlassianBlogLogoBrand />,
      inverse: <AtlassianBlogLogoInverse />,
      neutral: <AtlassianBlogLogoNeutral />
    },
    mark: {
      brand: <AtlassianBlogMarkBrand />,
      inverse: <AtlassianBlogMarkInverse />,
      neutral: <AtlassianBlogMarkNeutral />
    }
  },
  atlassiancertification: {
    logo: {
      brand: <AtlassianCertificationLogoBrand />,
      inverse: <AtlassianCertificationLogoInverse />,
      neutral: <AtlassianCertificationLogoNeutral />
    },
    mark: {
      brand: <AtlassianCertificationMarkBrand />,
      inverse: <AtlassianCertificationMarkInverse />,
      neutral: <AtlassianCertificationMarkNeutral />
    }
  },
  atlassiancommunity: {
    logo: {
      brand: <AtlassianCommunityLogoBrand />,
      inverse: <AtlassianCommunityLogoInverse />,
      neutral: <AtlassianCommunityLogoNeutral />
    },
    mark: {
      brand: <AtlassianCommunityMarkBrand />,
      inverse: <AtlassianCommunityMarkInverse />,
      neutral: <AtlassianCommunityMarkNeutral />
    }
  },
  atlassiandatalake: {
    logo: {
      brand: <AtlassianDataLakeLogoBrand />,
      inverse: <AtlassianDataLakeLogoInverse />,
      neutral: <AtlassianDataLakeLogoNeutral />
    },
    mark: {
      brand: <AtlassianDataLakeMarkBrand />,
      inverse: <AtlassianDataLakeMarkInverse />,
      neutral: <AtlassianDataLakeMarkNeutral />
    }
  },
  atlassiandesign: {
    logo: {
      brand: <AtlassianDesignLogoBrand />,
      inverse: <AtlassianDesignLogoInverse />,
      neutral: <AtlassianDesignLogoNeutral />
    },
    mark: {
      brand: <AtlassianDesignMarkBrand />,
      inverse: <AtlassianDesignMarkInverse />,
      neutral: <AtlassianDesignMarkNeutral />
    }
  },
  atlassiandeveloper: {
    logo: {
      brand: <AtlassianDeveloperLogoBrand />,
      inverse: <AtlassianDeveloperLogoInverse />,
      neutral: <AtlassianDeveloperLogoNeutral />
    },
    mark: {
      brand: <AtlassianDeveloperMarkBrand />,
      inverse: <AtlassianDeveloperMarkInverse />,
      neutral: <AtlassianDeveloperMarkNeutral />
    }
  },
  atlassiandocumentation: {
    logo: {
      brand: <AtlassianDocumentationLogoBrand />,
      inverse: <AtlassianDocumentationLogoInverse />,
      neutral: <AtlassianDocumentationLogoNeutral />
    },
    mark: {
      brand: <AtlassianDocumentationMarkBrand />,
      inverse: <AtlassianDocumentationMarkInverse />,
      neutral: <AtlassianDocumentationMarkNeutral />
    }
  },
  bitbucket: {
    logo: {
      brand: <BitbucketLogoBrand />,
      inverse: <BitbucketLogoInverse />,
      neutral: <BitbucketLogoNeutral />
    },
    mark: {
      brand: <BitbucketMarkBrand />,
      inverse: <BitbucketMarkInverse />,
      neutral: <BitbucketMarkNeutral />
    }
  },
  compass: {
    logo: {
      brand: <CompassLogoBrand />,
      inverse: <CompassLogoInverse />,
      neutral: <CompassLogoNeutral />
    },
    mark: {
      brand: <CompassMarkBrand />,
      inverse: <CompassMarkInverse />,
      neutral: <CompassMarkNeutral />
    }
  },
  confluence: {
    logo: {
      brand: <ConfluenceLogoBrand />,
      inverse: <ConfluenceLogoInverse />,
      neutral: <ConfluenceLogoNeutral />
    },
    mark: {
      brand: <ConfluenceMarkBrand />,
      inverse: <ConfluenceMarkInverse />,
      neutral: <ConfluenceMarkNeutral />
    }
  },
  jira: {
    logo: {
      brand: <JiraLogoBrand />,
      inverse: <JiraLogoInverse />,
      neutral: <JiraLogoNeutral />
    },
    mark: {
      brand: <JiraMarkBrand />,
      inverse: <JiraMarkInverse />,
      neutral: <JiraMarkNeutral />
    }
  },
  jiraalign: {
    logo: {
      brand: <JiraAlignLogoBrand />,
      inverse: <JiraAlignLogoInverse />,
      neutral: <JiraAlignLogoNeutral />
    },
    mark: {
      brand: <JiraAlignMarkBrand />,
      inverse: <JiraAlignMarkInverse />,
      neutral: <JiraAlignMarkNeutral />
    }
  },
  jiraproductdiscovery: {
    logo: {
      brand: <JiraServiceManagementLogoBrand />,
      inverse: <JiraServiceManagementLogoInverse />,
      neutral: <JiraServiceManagementLogoNeutral />
    },
    mark: {
      brand: <JiraServiceManagementMarkBrand />,
      inverse: <JiraServiceManagementMarkInverse />,
      neutral: <JiraServiceManagementMarkNeutral />
    }
  },
  jiraservicemanagement: {
    logo: {
      brand: <JiraProductDiscoveryLogoBrand />,
      inverse: <JiraProductDiscoveryLogoInverse />,
      neutral: <JiraProductDiscoveryLogoNeutral />
    },
    mark: {
      brand: <JiraProductDiscoveryMarkBrand />,
      inverse: <JiraProductDiscoveryMarkInverse />,
      neutral: <JiraProductDiscoveryMarkNeutral />
    }
  },
  jirasoftware: {
    logo: {
      brand: <JiraSoftwareLogoBrand />,
      inverse: <JiraSoftwareLogoInverse />,
      neutral: <JiraSoftwareLogoNeutral />
    },
    mark: {
      brand: <JiraSoftwareMarkBrand />,
      inverse: <JiraSoftwareMarkInverse />,
      neutral: <JiraSoftwareMarkNeutral />
    }
  },
  jiraworkmanagement: {
    logo: {
      brand: <JiraWorkManagementLogoBrand />,
      inverse: <JiraWorkManagementLogoInverse />,
      neutral: <JiraWorkManagementLogoNeutral />
    },
    mark: {
      brand: <JiraWorkManagementMarkBrand />,
      inverse: <JiraWorkManagementMarkInverse />,
      neutral: <JiraWorkManagementMarkNeutral />
    }
  },
  opsgenie: {
    logo: {
      brand: <OpsgenieLogoBrand />,
      inverse: <OpsgenieLogoInverse />,
      neutral: <OpsgenieLogoNeutral />
    },
    mark: {
      brand: <OpsgenieMarkBrand />,
      inverse: <OpsgenieMarkInverse />,
      neutral: <OpsgenieMarkNeutral />
    }
  },
  sourcetree: {
    logo: {
      brand: <SourcetreeLogoBrand />,
      inverse: <SourcetreeLogoInverse />,
      neutral: <SourcetreeLogoNeutral />
    },
    mark: {
      brand: <SourcetreeMarkBrand />,
      inverse: <SourcetreeMarkInverse />,
      neutral: <SourcetreeMarkNeutral />
    }
  },
  statuspage: {
    logo: {
      brand: <StatuspageLogoBrand />,
      inverse: <StatuspageLogoInverse />,
      neutral: <StatuspageLogoNeutral />
    },
    mark: {
      brand: <StatuspageMarkBrand />,
      inverse: <StatuspageMarkInverse />,
      neutral: <StatuspageMarkNeutral />
    }
  },
  trello: {
    logo: {
      brand: <TrelloLogoBrand />,
      inverse: <TrelloLogoInverse />,
      neutral: <TrelloLogoNeutral />
    },
    mark: {
      brand: <TrelloMarkBrand />,
      inverse: <TrelloMarkInverse />,
      neutral: <TrelloMarkNeutral />
    }
  }
};

export const Logo = ({ brand, type, appearance }: LogoProps) => {
  return Logos[brand] && Logos[brand][type][appearance];
};
